module.exports = __webpack_public_path__ + "748f47550205c20367b0aa1190f39d98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/detsky-tabor-1-6.jpg
// module id = 1216
// module chunks = 0